import { FC } from 'react';
import styled from 'styled-components';
import { getEasyLayout } from '@resistdesign/voltra/app/utils';

const PurposeText = styled.div`
  white-space: pre-wrap;
`;

const {
  layout: Layout,
  areas: { EmptyHeader, EmptyCenterLeft, CenterContent, EmptyCenterRight, EmptyFooter },
} = getEasyLayout()`
  empty-header empty-header empty-header, 1fr
  empty-center-left center-content empty-center-right, 1fr
  empty-footer empty-footer empty-footer, 1fr
  \\ 1fr 1fr 1fr
`;

export const ExpiredMessage: FC = () => (
  <Layout>
    <EmptyHeader />
    <EmptyHeader />
    <EmptyHeader />
    <EmptyCenterLeft />
    <CenterContent>
      <strong>Interview Expired:</strong>
      <br />
      <br />
      <PurposeText>
        The interview has expired.
        <br />
        Please contact an administrator for any additional help.
      </PurposeText>
    </CenterContent>
    <EmptyCenterRight />
    <EmptyFooter />
    <EmptyFooter />
    <EmptyFooter />
  </Layout>
);
